import { ComplexCommission, ComplexCommissionTier, DefaultInput, DoubleCommission } from "@PayPlans/helpers/DefaultSections/Commons";

const frontEndGrossProfit = () => {
	const max = 100000;
	return {
		from: DefaultInput(-max, "Dollar"),
		to: DefaultInput(max, "Dollar"),
		retail: DefaultInput(0, "Percent"),
		lease: DefaultInput(0, "Percent"),
		cash: DefaultInput(0, "Percent"),
		miniDeal: DefaultInput(0, "Dollar"),
	};
};

const financeCommission = () => {
	const max = 1000000;
	return {
		tiers: [
			ComplexCommissionTier([-max, "Dollar"], [max, "Dollar"], {
				commissions: [ComplexCommission([0, "Unit"], [1000000, "Unit"], { identifier: "commission", commission: [0, "Percent"] })],
			}),
		],
		products: [],
		frontEndGrossProfit: [frontEndGrossProfit()],
	};
};

const defaultFinanceManagerCommission = () => ({
	new: financeCommission(),
	preOwned: financeCommission(),
	globalGrossAndUnits: false,
	isGuaranteedDraw: false,
});

const defaultPerformanceNormalization = () => "NO_SPLIT";

const cashAndLeaseBumpDefault = () => ({
	metric: "PVR",
	bonus: false,
	tiers: [
		DoubleCommission([0, "Dollar"], [1000000, "Dollar"], {
			firstCommission: [0, "Percent"],
			secondCommission: [0, "Percent"],
		}),
	],
});

const citBonusDefault = () => {
	const maxUnits = 365;
	return {
		citType: "Dollars",
		relativeToStore: false,
		tiers: [
			ComplexCommissionTier([10000000, "Dollar"], [0, "Dollar"], {
				identifier: "bonuses",
				commissions: [ComplexCommission([maxUnits, "Unit"], [0, "Unit"], { commission: [0, "Percent"] })],
			}),
		],
	};
};

const departmentOverrideNetIncomeDefault = () => ({
	tiers: [ComplexCommission([0, "Dollar"], [1000000, "Dollar"], { commission: [0, "Percent"] })],
	chargeBacks: false,
	commissionPayouts: false,
	personalGrossProfit: false,
});

const maxPayoutDefault = () => ({
	frontend: DefaultInput(0, "Percent"),
	backend: DefaultInput(0, "Percent"),
	afterChargebacks: false,
});

const pvrQualifierTier = (args) => {
	const { from = 0, to = 0, adjustment = 0, adjustmentInput = "Percent" } = args || {};
	return {
		from: DefaultInput(from, "Dollar"),
		to: DefaultInput(to, "Dollar"),
		adjustment: DefaultInput(adjustment, adjustmentInput),
	};
};

const pvrQualifierDefault = (args) => {
	const { from = 0, to = 1000000, adjustment = 0, adjustmentInput = "Percent" } = args || {};
	return [pvrQualifierTier({ from, to: 0, adjustment, adjustmentInput }), pvrQualifierTier({ from, to, adjustment, adjustmentInput })];
};

export {
	cashAndLeaseBumpDefault as CashAndLeaseBumpDefault,
	citBonusDefault as CITBonusDefault,
	defaultFinanceManagerCommission as DefaultFinanceManagerCommission,
	defaultPerformanceNormalization as DefaultPerformanceNormalization,
	departmentOverrideNetIncomeDefault as DepartmentOverrideNetIncomeDefault,
	frontEndGrossProfit as FrontEndGrossProfit,
	maxPayoutDefault as MaxPayoutDefault,
	pvrQualifierDefault as PVRQualifierDefault,
	pvrQualifierTier as PVRQualifierTier,
};
